import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {
    TextFieldWithController,
    DatePickerWithController,
} from 'components/Common/Form/MuiInputs';
import teal from '@mui/material/colors/teal';

const AuthSignatureForm = () => {
    return (
        <Box sx={{ mb: 3 }}>
            <Box
                sx={{
                    p: { xs: 2, sm: 3 },
                    mb: 2,
                    backgroundColor: 'grey.50',
                    borderLeft: '3px solid',
                    borderColor: teal[500],
                    color: 'text.secondary',
                    lineHeight: 1.7,
                }}
            >
                By signing this form, you agree to a meeting with a sales agent
                to discuss the types of products you initialed above. Please
                note, the person who will discuss the products is either
                employed or contracted by a Medicare plan. They do not work
                directly for the Federal government. This individual may also be
                paid based on your enrollment in a plan. Signing this form does
                NOT obligate you to enroll in a plan, affect your current
                enrollment, or enroll you in a Medicare plan.
            </Box>
            <Typography
                variant="subtitle2"
                sx={{ mb: 1.5, fontWeight: 700, color: 'text.primary' }}
            >
                Beneficiary or Authorized Representative Signature and Signature
                Date:
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextFieldWithController
                        controllerProps={{ name: 'scopeAuthSignature' }}
                        textFieldProps={{
                            label: 'Signature - First and Last Name',
                            required: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DatePickerWithController
                        controllerProps={{ name: 'scopeAuthSignatureDate' }}
                        datePickerProps={{
                            label: 'Date',
                            views: ['year', 'month', 'day'],
                            timezone: 'UTC',
                        }}
                        errorAsPopper
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
export default AuthSignatureForm;
